import { Select } from 'antd';
import { useState } from 'react';

export type ExportDataSearchOption = {
  readonly value: string;
  readonly label: string;
};

type ExportDataSearchFuncProps = {
  readonly setSearchText?: (value: string) => void;
  readonly setSelectedValues: (values: readonly string[]) => void;
};

type ExportDataSearchProps = ExportDataSearchFuncProps & {
  readonly id: string;
  readonly selectedValues: readonly string[];
  readonly options: readonly ExportDataSearchOption[];
  readonly showArrow?: boolean;
  readonly loading?: boolean;
};

const ExportDataSearch = ({
  id,
  selectedValues,
  options,
  showArrow,
  loading,
  setSearchText,
  setSelectedValues,
}: ExportDataSearchProps) => {
  const [open, setOpen] = useState(false);

  const onSearch = (searchText: string) => {
    if (setSearchText !== undefined) {
      setSearchText(searchText);
    }
  };

  const onChange = (
    _: readonly string[],
    selectedOptions: ExportDataSearchOption | readonly ExportDataSearchOption[]
  ) => {
    if (selectedOptions instanceof Array) {
      setSelectedValues(selectedOptions.map((option) => option.value));
    } else {
      setSelectedValues([selectedOptions.value]);
    }
    setOpen(false);
    if (setSearchText !== undefined) {
      setSearchText('');
    }
  };

  return (
    <Select
      className="user-select"
      id={id}
      // We set this attribute same as id for accessability
      aria-activedescendant={id}
      // role must be explicitly set here for the provision of valid aria attributes
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      role={'combobox'}
      aria-expanded={open}
      aria-label="search-input"
      open={open}
      mode="multiple"
      style={{
        width: '100%',
        backgroundColor: 'transparent',
        flex: 'auto',
      }}
      value={selectedValues}
      filterOption={false}
      notFoundContent={null}
      onSearch={onSearch}
      onChange={onChange}
      options={[...options]}
      onDropdownVisibleChange={(visible) => setOpen(visible)}
      popupMatchSelectWidth={false}
      suffixIcon={showArrow === false ? null : undefined}
      loading={loading}
    />
  );
};

export default ExportDataSearch;
